import { atom } from "recoil";
import { Team } from "../model";

export const teamsState = atom<Team[] | undefined>({
  key: 'teamsState',
  default: undefined,
});